module.exports = __webpack_public_path__ + "img/logo-fairers-gradient.59fee690.svg";